/** A regular expression that matches Youtube URLs. */
export const YOUTUBE_RE =
  /https:\/\/((www\.)?youtube\.com|youtu\.be)\/(embed\/|watch\?v=)?([a-zA-Z0-9-_]+)/

/**
 * Returns true if the given URL is a valid YouTube URL, false otherwise.
 *
 * @param url The URL to check.
 * @returns A boolean indicating whether the URL is a valid YouTube URL.
 */
export function isYouTubeUrl(url: string) {
  return YOUTUBE_RE.test(url)
}

/**
 * Normalizes a YouTube URL into a valid embed URL.
 *
 * @param url The YouTube URL to normalize.
 * @returns The normalized YouTube URL.
 */
export function normalizeUrl(url: string) {
  return url.replace(YOUTUBE_RE, "https://www.youtube.com/embed/$4")
}

/**
 * Returns a thumbnail URL for a YouTube video.
 *
 * @param url The YouTube URL.
 * @param quality The thumbnail quality.
 * @returns A thumbnail URL.
 */
export function thumbnailUrl(url: string, quality: "default" | "hq" | "mq" | "sd" = "default") {
  const filename = quality === "default" ? "default.jpg" : `${quality}default.jpg`
  return url.replace(YOUTUBE_RE, `https://img.youtube.com/vi/$4/${filename}`)
}
